(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heirloom-sweaters"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.heirloom-mobile-nav nav a');
    if (link) link.closest('details').removeAttribute('open');
  });

  } catch(e) { console.error(e); }
})();
})();
